export enum LanguagePreferences {
    English = 'English',
    Spanish = 'Spanish'
}
